module.exports = __webpack_public_path__ + "static/media/revenue-operations-feature-tile-icon-03.1fb30f85.svg";